import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AgencyRequestComponent } from './agency-request.component';

const routes: Routes = [
  {
    path: '',
    component: AgencyRequestComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AgencyRequestRoutingModule {}
